import { Vector2 } from "../common/vector2.js";
import { ITransformParams } from "../types/transform_params.js";
import { Easing, TransformBase, TransformType } from "./transform_base.js";
import { Transformable } from "./transformable.js";

// Straight-line movement transform
export class TransformStraightMove<T extends Transformable> extends TransformBase
{
  private readonly target: T;
  private from: Vector2;
  private dest: Vector2;
  private is_fall:boolean = false;

  constructor(
    target: T,

    is_important: boolean,
    from: Vector2|null, // may be null for 'important'
    dest: Vector2,

    anim_start_time: number,
    duration_in_ms: number,

    optional_params: ITransformParams = {}
  )
  {
    super(
      TransformType.Moving,
      anim_start_time,
      duration_in_ms,
      is_important,
      optional_params
    );

    //console.log( 'TransformStraightMove.constructor()' );

    this.target = target;
    this.from   = from ?? new Vector2( 0, 0 );
    this.dest   = dest.clone();
    this.has_explicit_from = !is_important && from !== null;
  }

  private readonly has_explicit_from: boolean;
  public hasExplicitFrom(): boolean { return this.has_explicit_from; }

  public setFallFlag() { this.is_fall = true; }
  public isFall():boolean { return this.is_fall; }

  protected getTarget():any { return this.target; }

  protected initImportant():void
  {
    this.from = this.target.pixelPosImportant().clone();
    //console.log( `TransformStraightMove.initImportant()   from ${this.from}   dest ${this.dest}` );
  }

  protected onUpdateTransform( eased: number ): void
  {
    const pos = Vector2.lerp( this.from, this.dest, eased );

    //if ( pos.x > 450 && pos.y > 324 )
    //  console.log( `TransformStraightMove.onUpdateTransform( eased ${eased} )   from ${this.from.y}   dest ${this.dest.y}   pos ${pos.y}` );

    if ( this.isImportant() )
      this.target.setPixelPos( pos, false );
    else
      this.target.addToPixelPos( pos );
  }

  public startValue():Vector2 { return this.from; };
  public destValue ():Vector2 { return this.dest; }

  //public setStart      ( value:Vector2 ):void { this.from = value; }
  public setDestination( value:Vector2 ):void { this.dest = value; }

  public toStrTransform():string { return `TransformStraightMove   from ${this.from}  to ${this.dest}`; }
}
